import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class InstallmentPayment extends HTMLElement {
  constructor() {
    super();

    this.context = null;
    this.productForm = null;
    this.amountElement = null;
  }

  connectedCallback() {
    this.context = this.dataset.context;
    const scope = this.closest('product-card, [data-ref="product-section-content"], [data-ref="popup-content"]');
    this.productForm = scope?.querySelector('[data-ref="product-form"]') || this.closest('[data-ref="product-form"]');
    this.amountElement = this.querySelector('[data-ref="installment-amount"]');

    this.productForm?.addEventListener(ThemeEvents.formUpdated, this.updateAmount);
  }

  disconnectedCallback() {
    this.productForm?.removeEventListener(ThemeEvents.formUpdated, this.updateAmount);
  }

  updateAmount = (event) => {
    if (this.context == 'cart' || !this.amountElement) return;

    const price = event.detail?.prices?.price;
    if (price == null) return;

    const installments = Math.max(1, parseInt(this.dataset.installments, 10) || 1);
    this.amountElement.innerHTML = formatMoney(Math.round(price / installments));
  };
}

if (!customElements.get('installment-payment')) {
  customElements.define('installment-payment', InstallmentPayment);
}
